// getIsQuickpay.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { QUICKPAY_MAX_PURCHASE_COUNT } from '../RemoteConfigKeys.js';

/**
 * Whether the current user is in the guided-purchase ("quickpay") range — one
 * whose completed purchase count is at or below the configured threshold.
 * Guests (no purchase count) count as 0, and an unset config defaults to 0.
 * Drives which CTA copy variant is shown.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {boolean} True when the user is within the quickpay purchase range.
 */
const getIsQuickpay = createSelector(
  state => state.getIn(['me', 'purchaseCount']) || 0,
  state => getRemoteConfigData(state, QUICKPAY_MAX_PURCHASE_COUNT) || 0,
  (purchaseCount, maxPurchaseCount) => purchaseCount <= maxPurchaseCount
);

export default getIsQuickpay;
